import { render, staticRenderFns } from "./batch-printing.vue?vue&type=template&id=1065515c&scoped=true&"
import script from "./batch-printing.vue?vue&type=script&lang=ts&"
export * from "./batch-printing.vue?vue&type=script&lang=ts&"
import style0 from "./batch-printing.vue?vue&type=style&index=0&id=1065515c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1065515c",
  null
  
)

export default component.exports